<template>
  <v-dialog v-model="show" max-width="480px" width="100%" persistent scrollable>
    <v-card class="user-add-dialog">

      <v-card-title>ユーザー作成</v-card-title>

      <v-card-text>

        <v-alert :value="errors != null" transition="scale-transition" color="primary" dark>
          <ul><li v-for="e in errors">{{ e }}</li></ul>
        </v-alert>

        <div class="a-row">
          <v-text-field label="Email" v-model="email" hide-details clearable type="email" />
        </div>

        <div class="a-row">
          <v-text-field label="名前" v-model="name" hide-details clearable />
        </div>

        <div class="a-row">
          <v-select label="役割" v-model="role" :items="['admin', 'user']" hide-details />
        </div>

        <div class="a-row password">
          <v-text-field
            label="パスワード"
            v-model="password"
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'visibility' : 'visibility_off'"
            @click:append="showPassword = !showPassword"
            hide-details
          />
        </div>

        <div class="a-row">
          <v-text-field
            label="パスワードの確認"
            v-model="passwordConfirmation"
            :type="showPasswordConfirmation ? 'text' : 'password'"
            :append-icon="showPasswordConfirmation ? 'visibility' : 'visibility_off'"
            @click:append="showPasswordConfirmation = !showPasswordConfirmation"
            hide-details
          />
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed @click="cancelButtonClicked"><v-icon>cancel</v-icon>CANCEL</v-btn>
        <v-btn depressed color="primary" @click="addButtonClicked" class="add-button"><v-icon>save</v-icon>作成</v-btn>
      </v-card-actions>
    </v-card>

    <message-dialog ref="aMessageDialog" @ok-button-clicked="okButtonClicked" />

  </v-dialog>
</template>

<script>
import Common from './common.js'
import MessageDialog from './message_dialog.vue'

export default {
  components: {
    'message-dialog': MessageDialog
  },
  data() {
    return {
      show: false,
      errors: null,
      email: null,
      name: null,
      role: null,
      password: null,
      passwordConfirmation: null,
      showPassword: false,
      showPasswordConfirmation: false
    }
  },
  methods: {
    showDialog(user) {
      this.email = null
      this.name = null
      this.role = 'user'
      this.password = null
      this.passwordConfirmation = null
      this.show = true
    },
    cancelButtonClicked() {
      this.show = false
    },
    okButtonClicked(tag) {
      this.show = false
    },
    addButtonClicked() {
      this.addUser()
    },
    addUser() {
      this.errors = null
      let params = {
        user: {
          email: this.email,
          name: this.name,
          role: this.role,
          password: this.password,
          password_confirmation: this.passwordConfirmation
        }
      }
      this.$root.showActivityView()
      Common.axios(document).post('/console/users', params).then(response => {
        console.log(response)
        this.$root.hideActivityView()
        this.$refs.aMessageDialog.showDialog('Koetatsu Console', '作成しました')
        this.$emit('user-did-create')
      }).catch(error => {
        console.log(error)
        console.log(error.response)
        this.errors = error.response.data.errors
        this.$root.hideActivityView()
      })
    }
  }
}
</script>

<style scoped lang="scss">
.user-add-dialog {
  .a-row {
    margin: 16px 0 32px;
    &.checkbox {
      margin: 48px 0 0;
    }
    &.password {
      margin: 0 0 32px;
    }
  }
  .add-button {
    width: 96px;
  }
}
</style>
